import { FiltersState } from '@casops/store/slices/filtersSlice';
import { ComponentType, ReactElement, Ref } from 'react';

export interface FilterInputProps<T> {
  label?: ReactElement | string;
  elementRef: Ref<T>;
}

export type FilterElementType =
  | HTMLVdsBasicInputElement
  | HTMLVdsBasicDropdownElement
  | HTMLVdsBasicDropdownMultiselectElement;

export enum FilterElement {
  VdsInput = 'HTMLVdsBasicInputElement',
  VdsDropdown = 'HTMLVdsBasicDropdownElement',
  VdsDropdownMultiselect = 'HTMLVdsBasicDropdownMultiselectElement',
}

export type FilterName = keyof FiltersState;

interface FilterConfigModel<T extends FilterElementType, E extends FilterElement> {
  name: FilterName;
  FilterComponent: ComponentType<FilterInputProps<T>>;
  elementType: E;
}

type NumberFilterConfig = FilterConfigModel<HTMLVdsBasicInputElement, FilterElement.VdsInput>;
type DropdownFilterConfig = FilterConfigModel<
  HTMLVdsBasicDropdownElement,
  FilterElement.VdsDropdown
>;
type DropdownMultiselectFilterConfig = FilterConfigModel<
  HTMLVdsBasicDropdownMultiselectElement,
  FilterElement.VdsDropdownMultiselect
>;

export type FilterConfig =
  | NumberFilterConfig
  | DropdownFilterConfig
  | DropdownMultiselectFilterConfig;

export interface FilterWithOptions {
  name: FilterName;
  fullWidth?: boolean;
  labelTransKey?: string;
}

export type FiltersList = Array<FilterName | FilterWithOptions>;

export enum FilterGroup {
  AssetsList = 'AssetsList',
  Geofences = 'Geofences',
}
export interface FilterProps {
  countFilter?: number;
  countAll?: number;
  filterGroup?: FilterGroup;
}
